import { Button as HeadlessuiButton } from '@headlessui/react'
import { _t } from "core/language";
import { useMemo } from "react";

export interface ButtonProps {
  label: string;
  type?: "button" | "submit" | "reset" | undefined;
  classBtn?: string;
  disabled?: boolean;
  onClickBtn?: (e: any) => void;
  icon?: any;
  iconClassName?: string;
  primary?: boolean;
  outline?: boolean;
  size?: 'lg' | 'md' | 'sm' | string;
  rounded?: boolean;
  loading?: boolean;
  iconRight?: any;
}

const Button = ({
  label,
  type = 'button',
  classBtn,
  disabled,
  onClickBtn,
  icon,
  iconClassName = 'absolute left-4',
  primary = false,
  outline = false,
  size = 'lg',
  rounded = false,
  loading = false,
  iconRight = false,
}: ButtonProps) => {
  const handleClick = (e: any) => {
    if (type && type !== "submit" && !loading) {
      onClickBtn?.(e);
    }
  };

  const color = useMemo(() => {
    if (primary) {
      if (outline) {
        return 'ring-primary text-primary'
      }
      return 'bg-primary ring-orange-300 text-white !ring-0'
    }
    return 'bg-white ring-gray-300 ring-1';
  }, [primary, outline])

  const disabledClassName = useMemo(() => {
    return 'data-[disabled]:bg-[#f4f4f4] data-[disabled]:text-[#999999] data-[disabled]:ring-gray-300 data-[disabled]:!ring-1'
  }, [])

  const sizeClassName = useMemo(() => {
    if (size === 'lg') {
      return 'py-[14px] h-[50px]'
    }
    if (size === 'sm') {
      return 'py-[7px]'
    }
    return 'py-[10px]'
  }, [size])

  const fontSizeClassName = useMemo(() => {
    if (size === 'lg') {
      return '15px'
    }
    if (size === 'sm') {
      return '14px'
    }
    if (size === 'md') {
      return '14px'
    }
    return `${size}`
  }, [size])

  const roundedClassname = useMemo(() => {
    if (rounded) {
      return 'rounded-full'
    }
    return 'rounded-lg'
  }, [rounded]);

  console.log(icon, 'icon');
  
  return (
    <HeadlessuiButton
      className={`
        relative flex items-center justify-center ring-1 ring-inset 
        ${roundedClassname}
        ${sizeClassName}
        ${color}
        ${disabledClassName}
        ${classBtn}
      `}
      type={type}
      onClick={handleClick}
      disabled={disabled}
    >
      {(icon && icon !== '') && <img src={icon} alt="" className={iconClassName} />}
      <div className="flex items-center justify-center gap-1">
        <span
          className={`flex items-center justify-center gap-1`}
          style={{fontSize: fontSizeClassName}}
          dangerouslySetInnerHTML={{ __html: _t(label || '') }}
        />
        {!disabled && loading && 
          <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
        }
      </div>
      {
        iconRight && <img src={iconRight} alt="" className={"ml-2"} />
      }
    </HeadlessuiButton>
  );
};

export default Button;
